module.exports = __webpack_public_path__ + "static/media/download-dark.9e335e54.svg";